module.exports = __webpack_public_path__ + "img/43_12.3e9e52de.png";